import { MyCommonService } from './my-common.service';
import { BehaviorSubject } from "rxjs";
import { GlobalServiceService } from "./global-service.service";
import { environment } from "./../../../environments/environment.prod";
import { HttpClient, HttpParams } from "@angular/common/http";
import {Injectable, Inject, PLATFORM_ID} from "@angular/core";
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: "root"
})

export class PatientProfileService {

  patient:any = {};
  _afterviewinitArr = new BehaviorSubject<any>([]);
  minDate = new BehaviorSubject<any>("");
  title = new BehaviorSubject<any>("");
  appointment = new BehaviorSubject<any>("");
  resPostId = new BehaviorSubject<any>("");
  autocompleteOptions = new BehaviorSubject<any>("");
  showLoader = new BehaviorSubject<any>("");
  dentist = new BehaviorSubject<any>({});
  expiredlink = new BehaviorSubject<any>("");
  showimgprev = new BehaviorSubject<any>("");
  show_message_old_password = new BehaviorSubject<any>("");
  show_color = new BehaviorSubject<any>("");
  showSuccMsg = new BehaviorSubject<any>("");
  old_password_class = new BehaviorSubject<any>("");
  dentistLanguage = new BehaviorSubject<any>("");
  allLanguage = new BehaviorSubject<any>("");
  dentistSkill = new BehaviorSubject<any>("");
  docsMore = new BehaviorSubject<any>("");
  docfiles = new BehaviorSubject<any>("");
  docsExp = new BehaviorSubject<any>("");
  docexpfiles = new BehaviorSubject<any>("");
  pop_up_open_read = new BehaviorSubject<any>("");
  docsEdu = new BehaviorSubject<any>("");
  docedufiles = new BehaviorSubject<any>("");
  dentistAwards = new BehaviorSubject<any>("");
  dentistInsurance = new BehaviorSubject<any>("");
  currentDate = new BehaviorSubject<any>("");
  searchSelectAllSettings = new BehaviorSubject<any>("");
  cappatient = new BehaviorSubject<any>("");
  searchKeyword = new BehaviorSubject<any>("");
  succ_msg = new BehaviorSubject<any>("");
  //patientLogin = new BehaviorSubject<any>('');
  //activatedPatient = new BehaviorSubject<any>('');
  show_message = new BehaviorSubject<any>("");
  emailexitmsg = new BehaviorSubject<any>("");
  showalert = new BehaviorSubject<any>("");
  change_color = new BehaviorSubject<any>("");
  patientImage = new BehaviorSubject<any>("");
  showErrMsg = new BehaviorSubject<any>("");
  show_class = new BehaviorSubject<any>("");
  forgotForm = new BehaviorSubject<any>("");
  user = new BehaviorSubject<any>("");
  change_class = new BehaviorSubject<any>("");
  dentistClient = new BehaviorSubject<any>("");
  unreadChatCounter = new BehaviorSubject<any>("");
  show_message_email = new BehaviorSubject<any>("");
  //getPatientProfileData = new BehaviorSubject<any>('');
  //getUnreadChatCount = new BehaviorSubject<any>('');
  postList = new BehaviorSubject<any>("");
  postAttachmentPath = new BehaviorSubject<any>("");
  postDetails = new BehaviorSubject<any>({});
  postDetail = new BehaviorSubject<any>({});
  currentPage = new BehaviorSubject<any>("");
  limit = new BehaviorSubject<any>("");
  post_title = new BehaviorSubject<any>("");
  post_description = new BehaviorSubject<any>("");
  offset = new BehaviorSubject<any>("");
  totalItems = new BehaviorSubject<any>("");
  //fetchMyPost = new BehaviorSubject<any>('');
  openChatHeadWindow = new BehaviorSubject<any>("");
  currentPaged = new BehaviorSubject<any>("");
  pageSize = new BehaviorSubject<any>("");
  totalPage = new BehaviorSubject<any>("");
  selectedTab = new BehaviorSubject<any>("");
  recentpostList = new BehaviorSubject<any>([]);
  unreadpostList = new BehaviorSubject<any>([]);
  //openChatHead = new BehaviorSubject<any>('');
  unreadpostCount = new BehaviorSubject<any>("");
  messageLog = new BehaviorSubject<any>("");
  //fetchUnreadPost = new BehaviorSubject<any>('');
  //fetchUnreadPostCount = new BehaviorSubject<any>('');
  //fetchAllRecentPost = new BehaviorSubject<any>('');
  chatImagePath = new BehaviorSubject<any>("");
  message = new BehaviorSubject<any>("");

  patientId = new BehaviorSubject<any>("");
  patient_id = new BehaviorSubject<any>("");
  postId = new BehaviorSubject<any>("");
  currentTime = new BehaviorSubject<any>("");
  patientName = new BehaviorSubject<any>("");
  //readChat = new BehaviorSubject<any>('');
  chatIndex = new BehaviorSubject<any>("");
  fav = new BehaviorSubject<any>("");
  is_status = new BehaviorSubject<any>("");
  appointment_time = new BehaviorSubject<any>("");
  receiverName = new BehaviorSubject<any>("");
  doctorId = new BehaviorSubject<any>("");
  filename = new BehaviorSubject<any>("");
  saveRatingForm = new BehaviorSubject<any>("");
  //sendMessage = new BehaviorSubject<any>('');
  docedufilesname = new BehaviorSubject<any>("");
  key_array = new BehaviorSubject<any>("");
  postvalid = new BehaviorSubject<any>(1);
  show_message_confirm = new BehaviorSubject<any>("");
  confirm_class = new BehaviorSubject<any>("");
  $digest = new BehaviorSubject<any>("");
  dentistDetails = new BehaviorSubject<any>("");
  isFavourite = new BehaviorSubject<any>("");
  post = new BehaviorSubject<any>({});
  createPost = new BehaviorSubject<any>({});
  rating = new BehaviorSubject<any>({
    rate: 5
  });
  config = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  patient_checkbox = new BehaviorSubject<any>("");
  patient_checkbox2 = new BehaviorSubject<any>("");
  showErrMsg1 = new BehaviorSubject<any>("");
  private window: Window;


  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private global: GlobalServiceService,
    private router: Router,
    private myCommonService: MyCommonService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
    }
    this.minDate.next(new Date().toDateString());
  }

  angularForEach(values, func) {
    if (Array.isArray(values)) {
      values.forEach(func);
      return;
    }
    let keys = Object.keys(values);

    for (var i in keys) {
      let key = keys[i];
      let value = values[key];
      func(value, key);
    }
  }

      /*******************Rahul************************/
    // PatientProfileService.prototype.listDoctorDetails = function (data) {
    //     return this.http.post(environment.apiURL + "/list-doctor-details", data);
    // };

  listDoctorDetails(data) {
    return this.http.post(`${environment.apiURL}/list-doctor-details`, data, this.config);
  }

  getDoctorFavourite(data) {
    return this.http.post(`${environment.apiURL}/get-doctor-favourite`, data, this.config);
  }

  patientPhoneVerification(data) {
    this.global.showLoader.next(1);
    return this.http.post(`${environment.apiURL}/patient-phone-verification`, data);
  }

  patientOtpVerification(data) {
    this.global.showLoader.next(1);
    return this.http.post(`${environment.apiURL}/patient-otp-verification`, data);
  }
  patientNoSms(data) {
    this.global.showLoader.next(1);
    return this.http.post(`${environment.apiURL}/patient-no-sms`, data);
  }

  afterThankYou40Second(data) {
    return this.http.post(`${environment.apiURL}/after-thank-you-forty-second`, data);
  }

  after4Mins(data) {
    return this.http.post(`${environment.apiURL}/after-four-mins`, data);
  }
  /*******************Rahul************************/

  /*******************Vikas************************/
  getDentistDetail(data) {
    return this.http.post(`${environment.apiURL}/get-dentist-detail`, data);
  }
  getDentalCareList(data) {
    return this.http.post(`${environment.apiURL}/get-dental-care-list`, data);
  }
  getServiceCategoryList(data) {
    return this.http.post(`${environment.apiURL}/get-service-category-list`, data);
  }
  patientResetPassword(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/patient/patient-change-forgot-password`,
      data,
      config
    );
  }
  setFollowUp(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/follow-up`,
      data
    );
  }
  requestForAddDentist(data) {
    return this.http.post(`${environment.apiURL}/add-my-dentist`, data, this.config);
  }
  requestForRemoveDentist(data) {
    return this.http.post(`${environment.apiURL}/remove-my-dentist`, data, this.config);
  }
  getRecommendedArticle(data) {
    return this.http.post(`${environment.apiURL}/get-recommended-article`, data, this.config);
  }
  sendInvitation(data) {
    return this.http.post(`${environment.apiURL}/send-invitation`, data, this.config);
  }
  getDentistList(data) {
    return this.http.post(`${environment.apiURL}/get-dentist-list`, data, this.config);
  }
  storeLogActivity(data) {
    return this.http.post(`${environment.apiURL}/store-log-activity`, data, this.config);
  }
  requestVideoConsulation(data) {
    return this.http.post(`${environment.apiURL}/request-video-consulation`, data, this.config);
  }
  createProduct(data) {
    return this.http.post(`${environment.apiURL}/create-product`, data);
  }
  getProductDetail(data) {
    return this.http.post(`${environment.apiURL}/get-product-detail`, data);
  }
  getEditProductDetail(data) {
    return this.http.post(`${environment.apiURL}/get-edit-product-detail`, data);
  }
  updateProduct(data) {
    return this.http.post(`${environment.apiURL}/update-product`, data);
  }
  fetchProductInquiry(data) {
    return this.http.post(`${environment.apiURL}/fetch-product-inquiry`, data);
  }
  changeInquiryPostStatus(data) {
    return this.http.post(`${environment.apiURL}/change-inquiry-post-status`, data);
  }
  deleteInquiryPost(data) {
    return this.http.post(`${environment.apiURL}/delete-inquiry-post`, data);
  }
  getSupportVideo(data) {
    return this.http.post(`${environment.apiURL}/get-support-video`, data, this.config);
  }
  /*******************Vikas************************/

  getPatientsPost(data) {
    return this.http.post(`${environment.apiURL}/get-patients-post`, data, this.config);
  }

  totAttendantPostCount(data) {
    return this.http.post(`${environment.apiURL}/tot-attendant-post-count`, data, this.config);
  }

  totUnattendantPostCount(data) {
    return this.http.post(
      `${environment.apiURL}/tot-unattendant-post-count`,
      data, this.config
    );
  }

  getPatientPostDetails(data) {
    return this.http.post(`${environment.apiURL}/get-patient-post-details`, data, this.config);
  }
  getClinicReqId(data) {
    return this.http.post(`${environment.apiURL}/get-clinic-req-id`, data, this.config);
  }

  getAttendantPost(data, config) {
    return this.http.post(`${environment.apiURL}/get-attendant-post`, data, config);
  }

  getUnattendantPost(data, config) {
    return this.http.post(`${environment.apiURL}/get-unattendant-post`, data, config);
  }

  getArchivedPost(data, config) {
    return this.http.post(`${environment.apiURL}/get-archived-post`, data, config);
  }

  imageUploaded(data) {
    return this.http.post(`${environment.apiURL}/image-uploaded`, data);
  }

  // patientLogin(loginObj){
  //   return this.http.post(`${environment.apiURL}/patient-login`, loginObj);
  // }

  unreadChatCountForPatient(data, config) {

    let params = `auth_token=${data.auth_token}&patient_id=${data.patient_id}`;
    // const params = new HttpParams()
    // .set('auth_token', data.auth_token)
    // .set('patient_id', data.patient_id);
    return this.http.post(
      `${environment.apiURL}/unread-chat-count-for-patient`,

        params, config
      );
  }

  patientRegistration() {
    return this.http.post(`${environment.apiURL}/patient-registration`, {});
  }

  saveChatHistory(data) {
    return this.http.post(`${environment.apiURL}/save-chat-history`, data, this.config);
  }

  createPatientPost(data) {
    return this.http.post(`${environment.apiURL}/create-patient-post`, data,);
  }

  listPatientPost() {
    return this.http.post(`${environment.apiURL}/list-patient-post`, {});
  }

  changePatientPostStatus(data, config) {
    return this.http.post(
      `${environment.apiURL}/change-patient-post-status`, data, config
    );
  }

  deletePatientPost(data) {
    return this.http.post(`${environment.apiURL}/delete-patient-post`, data, this.config);
  }

  getRecentPost(data) {

    return this.http.post(`${environment.apiURL}/get-recent-post`, data, this.config);
  }

  getRecentPostCount(data, config) {

    let params = `auth_token=${data.auth_token}&patient_id=${data.patient_id}&is_read=${data.is_read}&mydentistid=${data.mydentistid}`;

    return this.http.post(`${environment.apiURL}/get-recent-post-count`, params, config);
  }

  readChatForPatient(data) {
    return this.http.post(`${environment.apiURL}/read-chat-for-patient`, data, this.config);
  }

  readChatPatient(data, config) {

    let params = `auth_token=${data.auth_token}&patient_id=${data.patient_id}&post_id=${data.post_id}`;

    return this.http.post(`${environment.apiURL}/read-chat-patient`, params, config);
  }

  closedPostChat(data, config) {
    let params = `auth_token=${data.auth_token}&patient_id=${data.patient_id}&doctor_id=${data.doctor_id}&post_id=${data.post_id}`;

    return this.http.post(`${environment.apiURL}/closed-post-chat`, params, config);
  }

  saveReviewRatingForDoctors(data) {
    return this.http.post(
      `${environment.apiURL}/save-review-rating-for-doctors`,
      data
    );
  }

  getPatientName(data) {
    return this.http.post(
      `${environment.apiURL}/get-patient-name`,
      data
    );
  }

  savePatientFeedback(data) {
    return this.http.post(
      `${environment.apiURL}/save-feedback-for-doctors`,
      data
    );
  }

  markFavouriteDoctors(data) {
    return this.http.post(`${environment.apiURL}/mark-favourite-doctors`, data);
  }

  patientActivatoin() {
    return this.http.post(
      `${environment.apiURL}/service/patient/patient-activation`,
      {}
    );
  }

  forgotPassword(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/patient/patient-forgot-password`,
      data,
      config
    );
  }

  checkLink() {
    return this.http.post(
      `${environment.apiURL}/service/patient/patient-check-link`,
      {}
    );
  }

  changeForgotPassword() {
    return this.http.post(
      `${environment.apiURL}/service/patient/patient-change-forgot-password`,
      {}
    );
  }

  changePassword(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/patient/change-password`, data, config
    );
  }

  editProfile(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/patient/edit-profile`,
      data, config
    );
  }

  updateProfile(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/patient/update-profile`,
      data, config
    );
  }
  addContact(data, config) {
    return this.http.post(
      `${environment.apiURL}/add-contact`,
      data, config
    );
  }
  chatImageUploaded(data) {
    return this.http.post(
      `${environment.chatImageuploadApiPath}/image-uploaded`,
      data
    );
  }

  registerIdealistic(data, config) {
    return this.http.post(`${environment.apiURL}/add-idealistic`, data, config);
  }

  // patient Login
  patientLogin(data) {
    this.global.showLoader.next(1);
    return this.http.post(`${environment.apiURL}/patient-login`, data, this.config);
  }

  // patietn Signup
  patientSignup(patient) {
    var data = {
      patient: patient,
      auth_token: environment.authToken
    };
    var config = {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    };
    return this.http.post(
      `${environment.apiURL}/patient-registration`,
      data,
      config
    );
  }

  patientEmailCheck(fieldval) {
    if (fieldval != "") {
      var data = {
        email: fieldval
      };
      var config = {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      };
      return this.http.post(
        `${environment.apiURL}/service/patient/patient-email-check`,
        data,
        config
      );
    }
  }

  fetchMyPost(data) {
    var config = {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    };
    return this.http.post(
      `${environment.apiURL}/list-patient-post`,
      data,
      config
    );
  }

  _scrollToTop() {
    if (this.myCommonService.isBrowser) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
          this.window.scrollTo(0, 0);
      });
    }
  }

  socialLogin(data){
    return this.http.post(`${environment.apiURL}/patient-social-login`, data, this.config);
  }

  setAppointment(data){
    return this.http.post(`${environment.apiURL}/set-appointment-patient`, data, this.config);
  }

  getMydentistMessage(data){
    return this.http.post(`${environment.apiURL}/get-smart-bot-greeting`, data, this.config);
  }

  getJwtTokenDentist(url) {
    return this.http.get(url);
  }

  sendEmailOnMessage(data) {
    return this.http.post(`${environment.apiURL}/v1/auth/send_email_on_message`, data);
  }

  chatwithadmin(data){
    return this.http.post(`${environment.apiURL}/create-chat-with-admin`, data);
  }

  sendPatientInviteEmail(data){
    return this.http.post(`${environment.apiURL}/send-patient-invite-email`, data);
  }
}
